import * as React from 'react';
import { useMemo } from 'react';

import { AppSection, ProductList } from './index';
import { useAppData, useIntl } from '../providers';
import { Category, Product } from '../interfaces';

interface BranchViewProps {
    category: Category;
}

const BranchView: React.FC<BranchViewProps> = ({ category }: BranchViewProps) => {
    const { translate } = useIntl();
    const { isShop } = useAppData();

    const collectProductsInSubcategories = (categories: Category[]): Product[] => {
        return categories.reduce<Product[]>((products, currentCategory): Product[] => {
            return products.concat(
                currentCategory.productChoices,
                collectProductsInSubcategories(currentCategory.subCategories)
            );
        }, []);
    };

    const productsInBranch = useMemo(() => {
        const products = category ? collectProductsInSubcategories([category]) : [];

        const productIds = [];

        if (!isShop) {
            return products;
        }

        return products
            .filter(product => {
                if (productIds.indexOf(product.id) == -1) {
                    productIds.push(product.id);
                    return true;
                }
                return false;
            })
            .sort((a, b) => {
                return a.label > b.label ? 1 : -1;
            });
    }, [category]);

    if (!category) return null;

    return (
        <AppSection>
            <h1>{translate('branchView.header', 'All products in category', { branch: category.label })}</h1>
            <ProductList products={productsInBranch} />
        </AppSection>
    );
};

export default React.memo(BranchView);
